import { render, staticRenderFns } from "./RegionalMappingFields.vue?vue&type=template&id=1971ed62"
import script from "./RegionalMappingFields.vue?vue&type=script&lang=js"
export * from "./RegionalMappingFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports